<template>
  <div class="online-studyEvaluate">
    <div class="train-Switch-box">
      <div class="train-Switch">
        <div class="switch-left">
          <div class="tabs">
            <span class="cursor" :class="unitvisibe==0?'color-base':'color-333'" @click="unit(0)">{{$store.state.globalTxt.examin1?$store.state.globalTxt.examin1:$t('Evaluation.unit')}}</span>
            <span class="cursor" :class="unitvisibe==1?'color-base':'color-333'" @click="unit(1)">{{$store.state.globalTxt.examin2?$store.state.globalTxt.examin2:$t('Evaluation.wrong')}}</span>
          </div>
        </div>
        <div class="switch-right">
          <div class="record btnShadow bg-base cursor" @click="recordList">{{$store.state.globalTxt.examin3?$store.state.globalTxt.examin3:$t('Evaluation.record')}}</div>
          <router-link tag="em" class="icon" :to="{path:'/studyEvaluate/evaluationList'}"></router-link>
        </div>
      </div>
    </div>
    <div class="unit-name">
      <h3>{{studentInfo.textbook_cnname}}</h3>
    </div>
    <div v-if="unitvisibe==0">
      <div class="train-list">
        <!-- 单元练习 -->
        <h3 class="ell-myTitle">{{$store.state.globalTxt.examin1?$store.state.globalTxt.examin1:$t('Evaluation.unit')}}</h3>
        <div class="item-box" style="padding-bottom:30px;">
          <div
            class="item"
            :class="{'cur':unitExercise==index}"
            v-for="(item,index) of praticeList"
            :key="index"
            @click="praticeChange(item,index)"
          >
            <!-- {{item.unit_id}} -->
            <input
              type="radio"
              name="radio"
              class="checked"
              :id="`one${index}`"
              :value="item.unit_id"
              v-model="picked[index]"
            />
            <label :for="`one${index}`" class="label-box">
              <span class="one">{{item.unit_name}}</span>
              <!-- <span class="two">{{item.word}}</span> -->
              <!-- <span class="option">{{item.unit_id}}</span> -->
            </label>
          </div>
        </div>
        <!-- 组合练习 -->
        <h3 class="ell-myTitle" v-if="praticeGroupList.length>0">{{$t('Evaluation.groupUnit')}}</h3>
        <div class="item-box">
          <div
            class="item"
            :class="{'cur':unitGroupExercise==index}"
            v-for="(item,index) of praticeGroupList"
            :key="index"
            @click="praticeGroupChange(item,index)"
          >
            <input
              type="radio"
              name="radio1"
              class="checked"
              :id="`two${index}`"
              :value="item.unitgroup_id"
              v-model="picked1[index]"
            />
            <label :for="`two${index}`" class="label-box">
              <span class="one">{{item.unitgroup_name}}</span>
              <!-- <span class="two">{{item.word}}</span> -->
              <!-- <span class="option">{{item.unit_id}}</span> -->
            </label>
          </div>
        </div>
      </div>
      <!-- 分项测验 -->
      <div class="Subtest-box">
        <h3>{{$store.state.globalTxt.examin4?$store.state.globalTxt.examin4:$t('Evaluation.itemTest')}}</h3>
        <div class="Subtest">
          <div
            class="item"
            v-for="(item,index) of testList"
            :key="index"
            @click="testChange(item,index)"
          >
            <input
              v-if="index==0"
              type="radio"
              name="radio3"
              class="word-icon-cur"
              :id="`three${index}`"
              :value="item.ability_id"
              :v-model="picked2[index]"
              :checked="index==0?true:false"
            />
            <input
              v-else
              type="radio"
              name="radio3"
              class="word-icon-cur"
              :id="`three${index}`"
              :value="item.ability_id"
              :v-model="picked2[index]"
            />
            <label :for="`three${index}`" class="label-box">
              <span class="word-icon"></span>
              <span class="word-text">{{item.ability_name}}</span>
            </label>
            <!-- <span class="word-icon" :class="{'word-icon-cur':testExercise==index}"></span>
            <span class="word-text">{{item.label}}</span>-->
          </div>
        </div>
      </div>
      <div tag="div" class="start-box btnShadow bg-base cursor" @click="start">{{$store.state.globalTxt.examin5?$store.state.globalTxt.examin5:$t('Evaluation.start')}}</div>
    </div>
    <div v-if="unitvisibe==1" class="errorPractice">
      <div class="img">
        <img src="@/assets/images/studyCenter/Evaluation/analysis.png" alt />
        <div class="my-friend">
          <span class="name">{{$t('Evaluation.dearFriend')}}</span>
          <p class="allNum">
            {{ $t('Evaluation.allSchoolTip') }}
            <span class="color-base">{{Wrong.num}}</span> {{$t('Evaluation.question')}}
          </p>
        </div>
      </div>
      <div v-if="Wrong.num !=0" class="start-box btnShadow bg-base cursor" @click="startWrong">{{$store.state.globalTxt.examin5?$store.state.globalTxt.examin5:$t('Evaluation.start')}}</div>
    </div>

    <!-- <router-link tag="div" :to="{path:'/subject'}" class="start-box btnShadow bg-base">开始练习</router-link> -->
    <message :message="message" :showTip="showTip" @hideTip="hideTip" />
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import message from "@/components/Common/message";
export default {
  name: "evaluateChild",
  components: {
    message
  },
  data() {
    return {
      message: "",
      showTip: false,
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        textbook_id: "", //教材ID
        textbook_cnname: "", //教材名称
        unit_id: "", //单元ID
        unitgroup_id: "", //组合单元ID
        ability_id: "", //能力ID
        isGroup: true, //是单元练习还是组合单元练习
        examine_branch: "", //检测编号
        examine_name: "" //检测名称
      },
      picked: [],
      unitvisibe: 0, //单元练习与错题练习 切换
      //单元 练习
      unitExercise: 0,
      praticeList: [],
      //单元综合 练习
      picked1: [],
      unitGroupExercise: -1,
      praticeGroupList: [],
      //分项测验
      picked2: [],
      testExercise: -1,
      testList: [],
      Wrong: {
        num: "" //错题数
      }
    };
  },
  mounted() {},
  updated() {},
  created() {
    clearInterval(this.timer_cout);
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.textbook_id = this.$route.query.textbook_id;
    this.studentInfo.textbook_cnname = unescape(
      this.$route.query.textbook_cnname
    );
    console.log(unescape(this.$route.query.textbook_cnname), "解码");
    console.log(this.$route.query.textbook_id);
    this.getInfo();
  },
  watch: {},
  computed: {},
  methods: {
    hideTip() {
      this.showTip = false;
    },
    //单元练习与错题练习 切换
    unit(val) {
      if (val == 0) {
        this.unitvisibe = 0;
      } else if (val == 1) {
        this.unitvisibe = 1;
        this.getWrongNum();
      }
    },
    //单元练习 - 单选
    praticeChange(item, index) {
      console.log(item, index);
      this.unitExercise = index;
      this.studentInfo.unit_id = item.unit_id;

      this.studentInfo.unitgroup_id = "";
      this.picked1 = [];
      this.unitGroupExercise = -1;
      this.studentInfo.isGroup = true;
      console.log(this.picked);
    },
    //单元综合练习 - 单选
    praticeGroupChange(item, index) {
      console.log(item, index);
      this.unitGroupExercise = index;
      this.studentInfo.unitgroup_id = item.unitgroup_id;

      this.studentInfo.unit_id = "";
      this.picked = [];
      this.unitExercise = -1;
      this.studentInfo.isGroup = false;
      console.log(this.picked1);
    },
    //分项测验 - 单选
    testChange(item, index) {
      console.log(item, index);
      this.testExercise = index;
      this.studentInfo.ability_id = item.ability_id;
    },
    //获取 测评 教材信息
    getInfo() {
      this.$store.dispatch("setLoadingStatus", true);
      evaluationStore
        .getInfo({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          textbook_id: this.studentInfo.textbook_id //教材ID
        })
        .then(res => {
          if (res.data.error == 0) {
            if (res.data.result.list.hasOwnProperty("units")) {
              const units = res.data.result.list.units;
              this.praticeList = [...units];
              this.picked.push(units[0].unit_id);
              this.studentInfo.unit_id = units[0].unit_id;
            }
            if (res.data.result.list.hasOwnProperty("groupUnits")) {
              const groupUnits = res.data.result.list.groupUnits;
              this.praticeGroupList = [...groupUnits];
            }
            if (res.data.result.list.hasOwnProperty("abilities")) {
              const abilities = res.data.result.list.abilities;
              this.testList = [...abilities];
              this.picked2.push(abilities[0].ability_id);
              this.studentInfo.ability_id = abilities[0].ability_id;
            }
          }
          this.$store.dispatch("setLoadingStatus", false);
        });
    },
    //开始练习 - 点击
    start() {
      if (this.studentInfo.isGroup) {
        //单元
        this.getUnitBranch();
      } else {
        //组合单元
        this.getGroupBranch();
      }
    },
    //开始进入做题 单元练习 页面 - 接口
    getUnitBranch() {
      evaluationStore
        .getUnitBranch({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          textbook_id: this.studentInfo.textbook_id, //教材 ID
          unit_id: this.studentInfo.unit_id, //单元ID
          ability_id: this.studentInfo.ability_id //能力ID
        })
        .then(res => {
          if (res.data.error == 0) {
            const { examine_branch, examine_name } = res.data.result.list;
            console.log(examine_branch, examine_name);
            this.$router.push({
              path: "/subject",
              query: {
                examine_branch: examine_branch,
                examine_name: escape(examine_name),
              }
            });
          } else {
            this.message = res.data.errortip;
            this.showTip = true;
          }
        });
    },
    //开始进入做题 组合单元练习 页面 - 接口
    getGroupBranch() {
      evaluationStore
        .getGroupBranch({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          textbook_id: this.studentInfo.textbook_id, //教材 ID
          unitgroup_id: this.studentInfo.unitgroup_id, //单元ID
          ability_id: this.studentInfo.ability_id //能力ID
        })
        .then(res => {
          if (res.data.error == 0) {
            console.log(res.data.result.list);
            const { examine_branch, examine_name } = res.data.result.list;
            this.$router.push({
              path: "/subject",
              query: {
                examine_branch: examine_branch,
                examine_name: escape(examine_name)
              }
            });
          } else {
            this.message = res.data.errortip;
            this.showTip = true;
          }
        });
    },
    //错题练习 获取所有错题 - 接口
    getWrongNum() {
      evaluationStore
        .getWrongNum({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          textbook_id: this.studentInfo.textbook_id //教材 ID
        })
        .then(res => {
          if (res.data.error == 0) {
            if(res.data.result.list){
              this.Wrong.num = res.data.result.list.num;
            }else{
              this.Wrong.num = 0;
            }
          }
        });
    },
    //错题练习 - 提交
    startWrong() {
      this.getWrongQuestionBranch();
    },
    //错题练习 页面 - 接口
    getWrongQuestionBranch() {
      evaluationStore
        .getWrongQuestionBranch({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          textbook_id: this.studentInfo.textbook_id //教材 ID
        })
        .then(res => {
          if (res.data.error == 0) {
            console.log(res.data.result.list);
            const { examine_branch, examine_name } = res.data.result.list;
            this.$router.push({
              path: "/subject",
              query: {
                examine_branch: examine_branch,
                examine_name: escape(examine_name),
                myIsErroy: 0, //我是错题 - 提交标识
                mySourceErroy:1,//错题练习 - 标识(和单园练习同页面的这个)
              }
            });
          } else {
            this.message = res.data.errortip;
            this.showTip = true;
          }
        });
    },
    //测评记录
    recordList() {
      this.$router.push({
        path: "/studyEvaluate/record",
        query: {
          textbook_id: this.studentInfo.textbook_id
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.ell-myTitle{
  font-size: 16px;
  color: #333;
  margin: 20px 0 15px 0;
  padding: 0 20px;
}
</style>
